import React from 'react';
import glamorous, { Div } from 'glamorous';

import { routes } from '../../../actions/events';
import * as types from '../../../routes/types';

import { font, media, palette } from '../../../styles';
import { rules as rulesCaption } from '../../typography/Caption';
import Button from '../../ui/Button';

const styleCellTicketsButton = {
  alignSelf: 'flex-end',

  [media('sm')]: {
    alignSelf: 'center',
  },
};

const DateText = glamorous.div(props => ({
  ...rulesCaption,

  [media('sm', { isMax: true })]: {
    ...rulesCaption,
    lineHeight: font.getLineHeight(1),
  },
}));

const DateTextSmall = glamorous.div(props => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  flexGrow: 1,
  fontWeight: props.fontWeight,
  fontSize: props.fontSize,
  lineHeight: font.getLineHeight(1),
  backgroundColor: props.backgroundColor,
  color: props.color,
  borderRight: props.borderRight,
}));

const TimeText = glamorous.div({
  ...rulesCaption,
});

const VenueTimeText = glamorous.span({
  display: 'none',

  [media('sm', { isMax: true })]: {
    display: 'inline',
  },
});

const CellDateTime = row => (
  <Div>
    <DateText>{row.value.date}</DateText>
    <TimeText>{row.value.time}</TimeText>
  </Div>
);


const CellDateTimeSmall = row => (
  <Div
    display="flex"
    flexDirection="column"
    height="100%"
    width="100%"
    fontWeight="bold"
  >
    <DateTextSmall
      color="#fff"
      backgroundColor={palette.primary.base}
      fontSize="0.85em"
    >
      {row.value.dayShort}
    </DateTextSmall>
    <DateTextSmall
      fontSize="0.7em"
      borderRight={`1px solid ${palette.default.lightest}`}
    >
      {row.value.month} {row.value.dayNum}
    </DateTextSmall>
  </Div>
);

const CellVenue = row => (
  <Div>
    <VenueTimeText>{row.original.dateTime.time} at </VenueTimeText>
    {row.value}
  </Div>
);


const CellTickets = row => (
  <Button
    label="Tickets"
    color="primary"
    style={styleCellTicketsButton}
  />
);

const sortAlpha = (a, b) => {
  if (a > b) return 1;
  if (a < b) return -1;

  return 0;
};

const sortDate = (a, b) => a.epochSeconds > b.epochSeconds ? 1 : -1;

const columnEvent = {
  Header: 'Event',
  className: 'CellEvent',
  accessor: 'name',
  minWidth: 100,
  sortMethod: sortAlpha,
};

const columnVenue = {
  Header: 'Venue',
  className: 'CellVenue',
  Cell: CellVenue,
  id: 'venue',
  minWidth: 80,
  accessor: 'displayVenue',
  sortMethod: sortAlpha,
};

const columnDateTime = {
  Header: 'Date / Time',
  headerClassName: 'justify-flex-end',
  accessor: 'dateTime',
  Cell: CellDateTime,
  className: 'CellDateTime',
  width: 208,
  sortMethod: sortDate,
};

const columnDateTimeSmall = {
  Header: 'Date / Time',
  headerClassName: 'ColumnDateTimeSmall',
  accessor: 'dateTime',
  Cell: CellDateTimeSmall,
  className: 'CellDateTimeSmall',
  sortMethod: sortDate,
};

const columnTickets = {
  Header: '',
  Cell: CellTickets,
  className: 'CellTickets',
  width: 128,
  sortable: false,
};

const columns = [
  columnDateTimeSmall,
  columnEvent,
  columnVenue,
  columnDateTime,
  columnTickets,
];

export default columns;



// WEBPACK FOOTER //
// ./src/components/features/EventListTable/columns.js